function loadItems(button) {
  const totalPages = parseInt(
    document.querySelector("[data-total-pages]").value,
    10
  );
  let currentPage = parseInt(
    document.querySelector("[data-current-page]").value,
    10
  );
  let currentPageScroll = currentPage + 1;

  currentPage = currentPage + 1;

  const rawValue = document.querySelector("[data-next-url]").value;

  const getUrlWithoutPhcursor = (value, pageValue) => {
    const url = new URL(value, window.location.origin);
    url.searchParams.set("page", pageValue);
    url.searchParams.delete("phcursor");
    return url.pathname + "?" + url.searchParams.toString();
  };

  const nextUrl = getUrlWithoutPhcursor(rawValue, currentPage);
  const nextUrlScroll = getUrlWithoutPhcursor(rawValue, currentPageScroll);

  // The page counter only moves on once that page is on screen, so a failed request
  // (a dropped phone connection) retries the same page instead of skipping it.
  let loaded = false;

  button.setAttribute("disabled", "");
  button.classList.add("loading");

  fetch(nextUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.text();
    })
    .then((responseHTML) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(responseHTML, "text/html");
      const newItems = doc.querySelector(".load-more-grid").innerHTML;
      const grid = document.querySelector(".load-more-grid");

      if (grid.hasAttribute("data-yc-instock-first")) {
        // Each page puts its in-stock cards first. Keep that true across pages too: new in-stock
        // cards go in before the first sold-out card already shown, new sold-out cards go last.
        const isSoldOut = (li) =>
          li.dataset.available ? li.dataset.available === "false" : !!li.querySelector(".badge--sold-out");
        const tpl = document.createElement("template");
        tpl.innerHTML = newItems;
        const firstSoldOut = Array.from(grid.children).find(isSoldOut) || null;
        let firstNewAbove = null;
        Array.from(tpl.content.children).forEach((li) => {
          if (isSoldOut(li)) grid.appendChild(li);
          else {
            grid.insertBefore(li, firstSoldOut);
            if (firstSoldOut && !firstNewAbove) firstNewAbove = li;
          }
        });
        // New in-stock cards land above the sold-out ones the shopper is looking at, so bring them into view.
        if (firstNewAbove) {
          const smooth = !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
          firstNewAbove.scrollIntoView({ block: "center", behavior: smooth ? "smooth" : "auto" });
        }
      } else {
        grid.insertAdjacentHTML("beforeend", newItems);
      }
      document.querySelector("[data-current-page]").value = currentPage;
      loaded = true;
      colorSwatches();
    })
    .catch((error) => {
      console.error("Error loading items:", error);
      button.removeAttribute("disabled");
      button.classList.remove("loading");
      // Infinite scroll stops watching before each request; re-arm it so the same page is retried.
      if (document.querySelector(".infinite-scroll__data")) setTimeout(checkVisibility, 3000);
    })
    .finally(() => {
      if (loaded && currentPage <= totalPages) {
        const scrollData = document.querySelector(".infinite-scroll__data");
        if (scrollData && currentPage !== totalPages) {
          const nextUrlInput = scrollData.querySelector("input[data-next-url]");
          const currentPageInput = scrollData.querySelector(
            "input[data-current-page]"
          );

          if (nextUrlInput) {
            nextUrlInput.dataset.nextUrl = nextUrlScroll;
            nextUrlInput.value = nextUrlScroll;
          }

          if (currentPageInput) {
            currentPageInput.dataset.currentPage = currentPage;
            currentPageInput.value = currentPage;
          }

          checkVisibility();
        }

        button.removeAttribute("disabled");
        button.classList.remove("loading");

        if (currentPage === totalPages) {
          button.remove();
        }
      }
    });
}

function checkVisibility() {
  const spinnerList = document.querySelectorAll(".js-infinite-scroll");
  spinnerList.forEach((spinner) => {
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadItems(spinner);
          sectionObserver.unobserve(entry.target);
        }
      });
    });

    sectionObserver.observe(spinner);
  });
}

function loadMore() {
  document.querySelectorAll(".js-load-more").forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    };
  });

  checkVisibility();
}

(function () {
  loadMore();
})();
